import React from "react";

import FilterButton from "../FilterButton";

import addedIcon from "../../../../../../assets/icons/checkbox-circle-line.svg";
import pendingIcon from "../../../../../../assets/icons/circle-line.svg";
import separatorIcon from "../../../../../../assets/images/product/specmanager/Seperator.svg";

import "./GlobalSpecFilters.css";

/**
 * Filter buttons for global test spec list (Spec Added / Spec Incomplete).
 * Part of GlobalTestSpec feature.
 */
function GlobalSpecFilters({
  filterFlag,
  handleFilterToggle,
  handleCloseFilterClick,
  loading,
}) {
  return (
    <div className="GlobalSpecFilters__Container">
      <FilterButton
        isActive={filterFlag === ""}
        icon={null}
        filterText="All"
        filterValue=""
        handleFilterToggle={handleFilterToggle}
        disable={loading}
        alt="allIcon"
      />
      <img src={separatorIcon} alt="separator" className="GlobalSpecFilters__SeparatorIcon" />
      <FilterButton
        isActive={filterFlag === "added"}
        icon={addedIcon}
        filterText="Spec Added"
        filterValue="added"
        handleFilterToggle={handleFilterToggle}
        handleCloseFilterClick={handleCloseFilterClick}
        disable={loading}
        alt="addedIcon"
      />
      <FilterButton
        isActive={filterFlag === "pending"}
        icon={pendingIcon}
        filterText="Spec Incomplete"
        filterValue="pending"
        handleFilterToggle={handleFilterToggle}
        handleCloseFilterClick={handleCloseFilterClick}
        disable={loading}
        alt="pendingIcon"
      />
    </div>
  );
}

export default GlobalSpecFilters;
